import React from 'react'
import { checkTextTranslation, translate } from '../../utils/useful'
import FixedView from '../FixedView'
import ColorInput from './ColorInput'

class BoxShadowInput extends React.Component {
    state = {
        locked: false,
        values: {},
        sides: ['H Offset', 'V Offset', 'Radius', 'Spread']
    }

    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.data && prevProps.data != this.props.data) {
            this.init()
        }
    }


    init() {
        // console.log(this.props.data)
        if (this.props.data) {
            let sections = String(this.props.data).split(' ')
            let values = {}
            let sides = this.state.sides
            let tempValues = []
            let tempUnits = []
            let tempSection

            sections.forEach((section, index) => {


                if (section.startsWith('#') || section.startsWith('rgb')) {
                    values.color = section
                } else {
                    tempSection = section
                    // console.log(section)
                    // let unit = 'px'
                    // let value
                    if (!section.includes('%')) {
                        tempValues.push(Number(section.replace('px', '')))
                        tempUnits.push('px')
                    } else {
                        tempValues.push(Number(section.replace('%', '')))
                        tempUnits.push('%')
                    }
                }
            });


            sides.forEach((side, index) => {
                let myIndex = index % sections.length
                values[side] = { value: (tempValues[myIndex] == 0 ? '' : tempValues[myIndex]), unit: tempUnits[myIndex] }
            });


            this.setState({ values })
            // console.log(values)
        }
    }



    changeInputValue(value) {

        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }

    changeInput = (key, value) => {

        let maxValue = this.props.header.information?.maxValue
        if (maxValue != null && value > maxValue) {
            return
        }
        let sides = this.state.sides
        let values = { ...this.state.values }

        let output

        if (key != 'color') {
            values[key] = { value: (value ?? 0), unit: 'px' }
        }
        output = ''
        sides.forEach(side => {
            let sideValue = values[side]?.value
            if (sideValue == '' || !sideValue) {
                sideValue = 0
            }
            output = output + sideValue + 'px '
        });

        if (key == 'color') {
            output = output + ' ' + (value ?? '')
            values[key] = value
        } else {
            output = output + ' ' + (values.color ?? '')
        }


        console.log(key, value)

        console.log(values)
        this.setState({ values })
        this.changeInputValue(output)


    }


    render() {


        return (
            <div className="w-100 h-100 flexc">

                {this.state.sides.map((side, index) => {
                    return (

                        <div className='mrd-1'>
                            <div className={"p-0 "+(this.props.inputClass)}>
                                <input disabled={this.props.header.information.disabled} autoFocus={this.props.header.information.autoFocus} ref={el => this.input = el} type="number" step="any" value={this.state.values[side]?.value != null ? this.state.values[side]?.value : ''} maxLength={this.props.header.information.maxLength} onChange={(e) => this.changeInput(side, e.target.value)} placeholder={translate('-')} className="transpanet-input text-center text-smaller " style={{height:38}} />
                            </div>
                            <p className='text-smallest mt-1 color-gray-2 text-center'>{translate(side)}</p>
                        </div>

                    )
                })}

                <div>
                    <button ref={(el) => this.colorNode = el} onClick={() => this.colorFixedView.showView()} className={"flexcc  px-1 " + this.props.inputClass}>
                        {/* <div className='br-20' style={{ width: 20, height: 20, backgroundColor: '#ee5050', border: '1px solid #eee' }}>

                        </div> */}
                        <ColorInput data={this.state.values?.color} changeValue={this.changeInput} header={{ key: 'color', information: { showBox: true } }} width={this.props.width} />

                    </button>


                    {/* <FixedView width={this.props.width} zIndex={10} ref={el => this.colorFixedView = el} nodeRef={this.colorNode} xOffset={0} bottomOffset={27} topOffset={0} maxWidth={260} > */}
                    {/* <ColorInput data={this.state.values?.color} changeValue={this.changeInput} header={{ key: 'color', information: {} }} width={this.props.width} /> */}
                    {/* </FixedView> */}

                    <p className='text-smallest mt-1 color-gray-2  text-center'>{translate("Color")}</p>

                </div>


            </div>
        )
    }
}

export default BoxShadowInput;